export const DAPP_INIT_ROUTE = "/dapp/init";
